import gameSettings from './constants/gameSettings';
import { getEquationOfLineFrom2Points } from './helpers/mathMethods';

export default class BackMVC {
    #lineEquationScaleFromGameDistanceCity;
    #lineEquationScaleFromGameDistanceMountains;
    #lineEquationScaleFromGameDistanceSky;
    #finalDistance;
    #salutesActive = false;
    #wrapper;
    #slowdownOverlay;
    #speedBoostOverlay;
    #blizzardOverlay;
    #salutesOverlay;
    #updateTimeout = 1000;
    #isUpdateCooldown = false;

    #gameProgressProperty = '--game-progress';
    #cityScaleProperty = '--city-scale';
    #mountainsScaleProperty = '--mountains-scale';
    #skyScaleProperty = '--sky-scale';
    #regionProgressProperty = '--{regionName}-progress';

    // TODO мб обновлять фон только начиная с какой-то дистанции
    constructor(finalDistance) {
        this.#finalDistance = finalDistance;
        this.setLineEquationScaleFromGameDistance(finalDistance);
        // this.#wrapper = document.getElementById('gameWrapper');
        this.#wrapper = document.querySelector('#game-back');
        this.#slowdownOverlay = document.querySelector(
            '#game-collision-overlay'
        );
        this.#speedBoostOverlay = document.querySelector('#game-speed-overlay');
        this.#blizzardOverlay = document.querySelector(
            '#game-blizzard-overlay'
        );
        this.#salutesOverlay = document.querySelector('#game-salutes-overlay');
        this.update(0.3);
        this.update100Vh();
    }

    get salutesActive() {
        return this.#salutesActive;
    }

    onGameStart() {
        this.#wrapper.classList.add('game-active');
    }

    onGameEnd() {
        this.#wrapper.classList.remove('game-active');
    }

    displaySlowdownAura() {
        this.#slowdownOverlay.classList.add('active');
    }

    hideSlowdownAura() {
        this.#slowdownOverlay.classList.remove('active');
    }

    displaySpeedBoostAura() {
        this.#speedBoostOverlay.classList.add('active');
    }

    hideSpeedBoostAura() {
        this.#speedBoostOverlay.classList.remove('active');
    }

    displayBlizzard() {
        this.#blizzardOverlay.classList.add('active');
    }

    hideBlizzard() {
        this.#blizzardOverlay.classList.remove('active');
    }

    showSalutes() {
        this.#salutesActive = true;
        this.#salutesOverlay.classList.add('active');
    }

    hideSalutes() {
        this.#salutesActive = false;
        this.#salutesOverlay.classList.remove('active');
    }

    setLineEquationScaleFromGameDistance(finalDistance) {
        this.#lineEquationScaleFromGameDistanceCity = getEquationOfLineFrom2Points(
            [0, gameSettings.backgroundParams.scaleFrom],
            [finalDistance, gameSettings.backgroundParams.scaleTo]
        );

        this.#lineEquationScaleFromGameDistanceMountains = getEquationOfLineFrom2Points(
            [0, gameSettings.backgroundParams.scaleFrom + 0.3],
            [finalDistance, gameSettings.backgroundParams.scaleTo]
        );

        this.#lineEquationScaleFromGameDistanceSky = getEquationOfLineFrom2Points(
            [0, gameSettings.backgroundParams.scaleFrom + 0.3 + 0.2],
            [finalDistance, gameSettings.backgroundParams.scaleTo]
        );
    }

    update(params) {
        if (!this.#wrapper || this.#isUpdateCooldown) return;

        const {
            distance,
            gameProgress
            // activeRegion,
            // activeRegionProgress
        } = params;

        const cityScale = this.#lineEquationScaleFromGameDistanceCity.k * distance
            + this.#lineEquationScaleFromGameDistanceCity.b;
        // const mountainsScale = this.#lineEquationScaleFromGameDistanceMountains.k * distance
        //     + this.#lineEquationScaleFromGameDistanceMountains.b;
        // const skyScale = this.#lineEquationScaleFromGameDistanceSky.k * distance
        //     + this.#lineEquationScaleFromGameDistanceSky.b;

        this.#wrapper.style.setProperty(
            this.#gameProgressProperty,
            gameProgress || 0
        );
        this.#wrapper.style.setProperty(
            this.#cityScaleProperty,
            cityScale || 0
        );
        // this.#wrapper.style.setProperty(this.#mountainsScaleProperty, mountainsScale);
        // this.#wrapper.style.setProperty(this.#skyScaleProperty, skyScale);

        // this.updateRegionProgress(activeRegion, activeRegionProgress);

        this.#isUpdateCooldown = true;

        setTimeout(() => {
            this.#isUpdateCooldown = false;
        }, this.#updateTimeout);
    }

    updateRegionProgress(activeRegion, activeRegionProgress = 0) {
        if (!activeRegion) return;
        const regionProgressVar = this.#regionProgressProperty.replace(
            '{regionName}',
            activeRegion.name
        );

        this.#wrapper.style.setProperty(
            regionProgressVar,
            activeRegionProgress
        );
    }

    resetAllRegionsProgress(regions) {
        regions.forEach((region) => {
            this.updateRegionProgress(region, 0);
        });
    }

    update100Vh() {
        this.#wrapper.style.setProperty('--100vh', `${window.innerHeight}px`);
    }
}
